import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Outlet, useLocation } from 'react-router-dom';
import RouteChangeTracker from './RouteChangeTracker';

import Gnb from 'pages/common/gnb/Gnb';

import { extendLogin } from 'apis/auth/login';
import { fetchMarketplaces } from 'apis/marketplace';
import { setUserState } from 'features/userSlice';
import { setMarketplaces } from 'features/commonSlice';
import { setDocumentTitle } from 'utils';

import './App.css';
import { message } from 'antd';

const App = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const [didExtendLogin, setDidExtendLogin] = useState(false);

  RouteChangeTracker();

  useEffect(() => {
    setDocumentTitle();
    window.scroll(0, 0);
  }, [location]);

  useEffect(() => {
    extendLogin()
      .then((loginUser) => dispatch(setUserState(loginUser)))
      .finally(() => setDidExtendLogin(true));
  }, []);

  useEffect(() => {
    fetchMarketplaces()
      .then((marketplaces) => dispatch(setMarketplaces(marketplaces)))
      .catch(() => message.error('마켓플레이스 정보를 불러올 수 없습니다. 잠시 후 다시 시도해주세요.'));
  }, []);

  return (
    didExtendLogin && (
      <>
        <nav>
          <Gnb />
        </nav>
        <main>
          <Outlet />
        </main>
      </>
    )
  );
};

export default App;
